import TxTileLayer from "./components/TxTileLayer";


export default {
    install(Vue, option) {

        Vue.component('TxTileLayer', TxTileLayer)
    }
};